export const defaultVideoAnalyticsFilters = {
  'event^people_count__gte:integer': '',
  'event^people_count__lt:integer': '',
  'event^fight_score__gtr:numeric': '',
  'event^fight_score__lt:numeric': '',
  'event^weapon_score__gte:numeric': '',
  'event^weapon_score__lt:numeric': '',
  'event^fire_score__gte:numeric': '',
  'event^fire_score__lt:numeric': '',
  'event^facecover_score__gte:numeric': '',
  'event^facecover_score__lt:numeric': '',
  'event^niqab_score__gte:numeric': '',
  'event^niqab_score__lt:numeric': '',
  'event^balaclava_score__gte:numeric': '',
  'event^balaclava_score__lt:numeric': '',
  'event^other_score__gte:numeric': '',
  'event^other_score__lt:numeric': '',
  'event^lying_score__gte:numeric': '',
  'event^lying_score__lt:numeric': '',
  'event^handsup_score__gte:numeric': '',
  'event^handsup_score__lt:numeric': '',
  'event^fall_score__gte:numeric': '',
  'event^fall_score__lt:numeric': '',
};

export const defaultFilters = {
  ...defaultVideoAnalyticsFilters,
  event_type: null,
  stream_ids: null,
  event_create_time__gte: null,
  event_create_time__lt: null,
  cities: '',
  areas: '',
  districts: '',
  streets: '',
  house_numbers: '',
  origin_longitude: '',
  longitude_delta: '',
  origin_latitude: '',
  latitude_delta: '',
};
